module.exports = __webpack_public_path__ + "01a240b5d52c5796e8f19a640bbbe363.svg";